import React, { ElementType } from 'react';

type Variant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'body'
  | 'body-small'
  | 'small';

interface Props {
  variant: Variant;
  children: React.ReactNode;
  className?: string;
  as?: ElementType;
}

const tags: Record<Variant, ElementType> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  body: 'p',
  'body-small': 'p',
  small: 'span',
};

const sizes: Record<Variant, string> = {
  h1: 'lg:text-5xl text-4xl',
  h2: 'lg:text-4xl text-3xl',
  h3: 'lg:text-3xl text-2xl',
  h4: 'lg:text-2xl text-xl',
  h5: 'lg:text-xl  text-lg',
  body: 'lg:text-lg text-base',
  'body-small': 'lg:text-base text-sm',
  small: 'lg:text-sm text-xs',
};

const Typography = ({ variant, children, className, as }: Props) => {
  const sizeClasses = sizes[variant];
  const Tag = as || tags[variant];

  return <Tag className={`${sizeClasses} ${className}`}>{children}</Tag>;
};

export default Typography;
